import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CheckListFilter } from '@app/modules/table/classes/column-filters/check-list/check-list-filter.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';
import { TimeOffv3StatusDisplayOptions } from '@app/types/translatables/time-off-v3-display.options';
import { TimeOffRequest } from '@models/time-off-v3/time-off-request.model';

export class StatusColumn extends BadgeColumn<TimeOffRequest> {
    title = 'time-off-v3.status';
    property = 'status';
    sortField = 'status';
    sortable = true;
    type: CellDisplay = CellDisplay.badge;

    constructor() {
        super();

        const options = [
            { label: 'time-off-v3.pending', value: 'pending' },
            { label: 'time-off-v3.approved', value: 'approved' },
            { label: 'time-off-v3.denied', value: 'denied' },
        ];

        this.filter = new CheckListFilter('status', options, this.title);
    }

    getBadgeDisplay(request: TimeOffRequest): BadgeDisplay | undefined {
        return {
            type: request.getBadgeType(),
            label: TimeOffv3StatusDisplayOptions[request.status] ?? request.status.toUpperCase(),
        };
    }
}
